export default __webpack_public_path__ + "static/media/stringy_hair.54a0d351.png";